module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28838",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9595",
      "ably-hubspot-js": "static-2.4635",
      "atom": "static-1.4990",
      "conversations-async-data": "static-2.7586",
      "conversations-error-reporting": "static-1.8800",
      "conversations-internal-pub-sub": "static-1.15890",
      "conversations-internal-schema": "static-1.12709",
      "conversations-message-history": "static-1.12435",
      "conversations-test-sdk": "static-1.10421",
      "conversations-visitor-experience-components": "static-1.22201",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5514",
      "hs-test-utils": "static-1.7932",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11379",
      "I18n": "static-7.1605",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2937",
      "jasmine-runner": "static-1.6387",
      "quartz": "static-1.6896",
      "react-dlb": "static-1.77",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.63",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4392",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4451",
      "usage-tracker": "static-1.7256",
      "usage-tracker-core": "static-1.7106",
      "usage-tracker-public": "static-1.7067",
      "viral-links-lib": "static-1.6969",
      "visitor-ui-component-library": "static-1.6056",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4728",
      "conversations-prop-types": "static-1.7374",
      "conversations-visitor-message-history": "static-1.20938",
      "cssUtils": "static-1.772",
      "enviro": "static-4.428",
      "flux-actions": "static-1.325",
      "foundations-components": "static-1.7772",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6141",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.184",
      "react-aria": "static-1.64",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1.16579",
      "react-utils": "static-2.5278",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8064",
      "signup-constants": "static-1.18706",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5670",
      "visitor-ui-component-library-icons": "static-1.5867",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3337",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.84",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.80",
      "quartz-config": "static-1.674",
      "quartz-core": "static-1.6115",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4771",
      "foundations-theming": "static-1.4334",
      "UIComponents": "static-3.8326",
      "customer-data-email": "static-1.17895",
      "cv-backend-services": "static-1.1542",
      "immutable-less": "static-1.4572",
      "conversations-skeleton-state": "static-1.7170",
      "crm-events-viz-core": "static-1.32917",
      "customer-data-objects": "static-1.7580",
      "icons": "static-2.639",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4564",
      "ui-images": "static-2.1132",
      "HeadJS": "static-2.736",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3043",
      "msw": "static-1.39",
      "testing-library": "static-1.150",
      "i18n-data": "static-1.219",
      "moment-timezone": "static-5.81",
      "jasmine": "static-4.4243",
      "signup-ui-url-generator": "static-2.7953",
      "HubStyle": "static-2.11687",
      "quartz-i18n": "static-1.571",
      "sassPrefix": "static-1.154",
      "bend-plugin-foundations-components": "static-1.4041",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2050",
      "hs-story-utils": "static-1.9350",
      "react-virtualized": "static-2.97",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1585",
      "ui-fonts": "static-1.641",
      "hs-locale-management": "static-1.19",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3852",
      "history": "static-4.47",
      "quartz-routing": "static-1.326",
      "usage-tracker-anonymous": "static-1.5673",
      "bender-build-tools": "static-1.3093",
      "dispatcher": "static-1.134",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.821",
      "hubspotter-http": "static-1.4587",
      "mobile-manifest-mixins": "static-1.510",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.571",
      "quartz-head": "static-1.561",
      "quartz-test": "static-1.571",
      "quartz-tracking": "static-1.275",
      "usage-tracker-container": "static-1.7246",
      "bend-plugin-foundations-theming": "static-1.2817",
      "foundations-theming-base": "static-1.3319",
      "stylex": "static-1.30",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4570",
      "customer-data-ui-utilities": "static-1.9746",
      "FileManagerCore": "static-1.38866",
      "FileManagerLib": "static-1.39007",
      "hubspot-apollo-client": "static-1.4797",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5163",
      "ui-gdpr-components": "static-1.10267",
      "ts-schema": "static-1.4013",
      "ai-components-ui-library": "static-1.8738",
      "avatar-components": "static-1.2413",
      "content-assistance-lib": "static-1.7634",
      "crm-component-utils": "static-1.38856",
      "crm-display-components": "static-1.24606",
      "crm-fe-perf": "static-1.22825",
      "crm-links": "static-1.6198",
      "crm-message-bus": "static-1.42763",
      "crm-search-service-types": "static-1.1071",
      "crm-source-interpretation-lib": "static-1.5255",
      "customer-data-communicator": "static-1.45281",
      "customer-data-filters-ui": "static-1.39458",
      "customer-data-objects-ui-components": "static-1.12941",
      "customer-data-properties": "static-1.51260",
      "customer-data-rte": "static-1.32785",
      "draft-plugins": "static-2.21534",
      "file-manager-components": "static-1.23367",
      "framework-data-schema-resolvers": "static-1.6794",
      "frontend-preferences-client": "static-1.7845",
      "hubspot-prosemirror": "static-1.18004",
      "object-comments-thread-lib": "static-1.10441",
      "prosemirror-user-and-team-at-mentions": "static-1.419",
      "reference-resolvers-lite": "static-1.8011",
      "ui-addon-upgrades": "static-9.17871",
      "universal-associations-select": "static-1.10933",
      "universal-record-utils-lib": "static-1.638",
      "inbound-db-properties-service-client": "static-1.3777",
      "property-translator": "static-1.5324",
      "chirp-fetch": "static-1.1802",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9779",
      "hubspotter-http-shared-msw-handlers": "static-1.9777",
      "usage-tracker-session-replay": "static-1.4942",
      "react-dnd-compat": "static-1.4539",
      "audio-components": "static-1.5796",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29152",
      "FileManagerImages": "static-1.36518",
      "foundations-components-legacy": "static-1.797",
      "immerable": "static-1.4072",
      "ui-universal-auth": "static-1.8873",
      "video-components": "static-1.13021",
      "video-data-lib": "static-1.34676",
      "video-embed": "static-1.35510",
      "hubspot-apollo-cache": "static-1.256",
      "chatspot-core": "static-1.20916",
      "ContentUtils": "static-1.68107",
      "copilot-toolkit": "static-1.10903",
      "superstore": "static-1.4688",
      "ui-addon-video-player": "static-1.8616",
      "ui-coaching-tips": "static-1.28315",
      "card-properties-lib": "static-1.43932",
      "commerce-subscription-lib": "static-1.36869",
      "crm-actions": "static-1.6237",
      "crm-cards-sdk": "static-1.43342",
      "customer-data-properties-shared-msw-handlers": "static-1.9106",
      "customer-data-property-utils": "static-1.8004",
      "customer-data-tracking": "static-1.6804",
      "hs-resources": "static-1.60",
      "inbound-db-meta-service-client": "static-1.3525",
      "pulse": "static-1.467",
      "framework-data-table": "static-2.11729",
      "location-customization-utils-lib": "static-1.8994",
      "calling-error-reporting": "static-1.31227",
      "calling-internal-common": "static-1.31221",
      "calling-usage-tracker": "static-1.6460",
      "crm_data": "static-4.91700",
      "customer-data-content": "static-1.27127",
      "draft-content-plugins": "static-1.28053",
      "draft-convert": "static-2.71",
      "draft-extend": "static-3.73",
      "draft-js": "static-5.76",
      "draft-signature-plugin": "static-1.23857",
      "EmailSignatureEditor": "static-1.24199",
      "hubspot-prosemirror-plugins": "static-1.17996",
      "integration-settings-components": "static-1.15231",
      "integrations-lib": "static-1.15856",
      "integrations-tracking-lib": "static-1.5516",
      "native-integrations-shared-strings": "static-1.7705",
      "nav-meta": "static-1.29375",
      "onboarding-scopes": "static-1.6384",
      "outreach-assistant-email-generation": "static-1.6056",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37761",
      "react-colorpicker": "static-2.10129",
      "reference-resolvers": "static-1.8088",
      "rich-text-lib": "static-1.19695",
      "sales-email-signature-service-client": "static-1.3762",
      "sequences-lib": "static-1.7904",
      "ui-addon-i18n": "static-1.11069",
      "ui-addon-iframeable": "static-1.8970",
      "ui-business-units-lib": "static-1.8961",
      "ui-shepherd-react": "static-3.10068",
      "user-context": "static-1.5020",
      "whatsapp-sending-lib": "static-1.5390",
      "customer-data-filters-ui-msw-helpers": "static-1.21893",
      "customer-data-reference-ui-components": "static-1.13075",
      "FormUrlGenerator": "static-2.4638",
      "framework-builder-read-service-client": "static-1.3944",
      "framework-data-schema-quick-fetch": "static-1.6699",
      "multi-account-reference-resolvers": "static-1.896",
      "onboarding-tours": "static-1.16452",
      "reporting-datasets-permissions-lib": "static-1.13437",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21440",
      "calling-global-api": "static-1.64184",
      "calling-lifecycle-internal": "static-1.65566",
      "calling-lifecycle-messages": "static-1.57860",
      "commerce-products-lib": "static-1.9223",
      "conditional-properties-service-client": "static-1.3732",
      "external-options-client-types": "static-1.4093",
      "google-libphonenumber": "static-1.36",
      "inbounddb-objects-service-types": "static-1.4158",
      "meetings-icalendar-utils-lib": "static-1.549",
      "multi-currency-client-types": "static-1.3626",
      "object-builder-ui-client": "static-1.48467",
      "pipeline-validation-client-types": "static-1.3901",
      "property-value-citations": "static-1.1874",
      "smart-property-lib": "static-1.6516",
      "tiered-pricing": "static-1.1043",
      "ui-addon-form-validation": "static-1.10910",
      "video-components-external": "static-1.11018",
      "batch-promise": "static-1.1472",
      "crm-pipelines-api-client-types": "static-1.4077",
      "persist-promise": "static-1.3629",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25126",
      "knowledge-content-types": "static-1.8465",
      "payment-link-components": "static-1.23300",
      "ui-addon-emoji-picker": "static-1.9806",
      "call-summary": "static-1.38874",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9925",
      "laboratory-lib": "static-3.7078",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5723",
      "crm-object-search-query-utilities": "static-1.9393",
      "amplitude-session-replay-browser": "static-1.58",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.668",
      "content-icons-ui": "static-1.2205",
      "social-insights-client-types": "static-1.21858",
      "outpost": "static-1.4110",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4729",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5513",
      "magpie-types": "static-1.4973",
      "simple-logging-lib": "static-1.2971",
      "growth-onboarding-feedback-components": "static-1.6502",
      "customer-data-sidebar": "static-2.45778",
      "enrichment-properties-lib": "static-1.15634",
      "commerce-billing-lib": "static-1.18838",
      "commerce-shared-components-lib": "static-1.18303",
      "commerce-tools-ui-lib": "static-1.10162",
      "directed-graph": "static-1.857",
      "event-emitter": "static-1.867",
      "fast-json-patch": "static-1.61",
      "customer-data-associations": "static-1.7246",
      "deal-intel-decorators": "static-1.1715",
      "reporting-data": "static-1.67149",
      "tanstack-virtual": "static-1.28",
      "ui-addon-draggable": "static-3.4688",
      "crm-record-cards-service-types": "static-1.3545",
      "self-service-api": "static-1.10164",
      "crm_universal": "static-1.21867",
      "SalesContentIndexUI": "static-3.9117",
      "content-embed-lib": "static-1.7260",
      "data-model-builder-lib": "static-1.12076",
      "remote-ui": "static-1.63",
      "ui-components-test-utils": "static-1.5517",
      "ui-extensions-remote-renderer": "static-1.16774",
      "universal-page-editor-lib": "static-1.2929",
      "integrations-error-boundary-lib": "static-1.13271",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10293",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.387",
      "messaging-types-lib": "static-1.45742",
      "data-token-picker": "static-1.16266",
      "sequences-client-types-lib": "static-1.7761",
      "foundations-components-test-utils": "static-1.5255",
      "navigation-messaging": "static-1.7065",
      "getting-started-shared-tasks": "static-1.18270",
      "getting-started-shared-tasks-store": "static-1.17388",
      "onboarding-tours-utils": "static-1.518",
      "messaging-usage-based-billing-components-lib": "static-1.867",
      "whatsapp-management-lib": "static-1.8549",
      "growth-data-modal": "static-1.5304",
      "growth-onboarding-confetti": "static-1.2990",
      "growth-onboarding-next-action-utils": "static-1.1678",
      "navigation-components": "static-1.17738",
      "onboarding-tours-client": "static-1.4666",
      "ui-shepherd-tracker": "static-1.7449",
      "shared-worker-versioning": "static-1.10957",
      "voice-sms-access-library": "static-1.670",
      "commerce-permissions": "static-1.685",
      "products-iframe-lib": "static-1.7698",
      "products-ui-components-shared-msw-handlers": "static-1.10161",
      "data-agent-kit": "static-1.68",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9862",
      "fsm": "static-1.3654",
      "policy-lib": "static-1.6703",
      "react-tinymce": "static-1.55007",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54133",
      "tinymce-plugins": "static-1.57247",
      "tinymce-themes": "static-1.56103",
      "content-media-composition-data-lib": "static-1.11992",
      "content-media-compositions": "static-2.15999",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18788",
      "ui-addon-opt": "static-4.8300",
      "commerce-tours-lib": "static-1.5947",
      "growth-onboarding-reliability": "static-1.5004",
      "sales-checkout-service-client": "static-1.3569",
      "ai-addon-copilot-preview": "static-1.7950",
      "calling-cross-tab-library": "static-1.19195",
      "calling-lifecycle-usage-tracker": "static-1.8487",
      "wootric-nps": "static-1.6902",
      "nav-client-types": "static-1.2277",
      "purchase-motions-api": "static-1.5726",
      "reactive-lib": "static-1.643",
      "card-payment-highlight-lib": "static-1.36934",
      "card-subscription-highlight-lib": "static-1.39292",
      "commerce-contract-lib": "static-1.11685",
      "invoices-highlight-card-lib": "static-1.54453",
      "orders-highlight-card-lib": "static-1.21234",
      "products-highlight-card-lib": "static-1.17507",
      "quotes-highlight-card-lib": "static-1.71671",
      "usage-based-billing-components-lib": "static-1.8396",
      "utility-belt": "static-1.2459",
      "payments-enrollment-embed-lib": "static-1.22391",
      "stripe-embedded-components": "static-1.7364",
      "growth-onboarding-empty-states": "static-1.5571",
      "InboxConnectUtils": "static-4.14584",
      "payments-post-enroll-local-storage-lib": "static-1.5031",
      "qrcode-generator": "static-1.67",
      "trials-service-types": "static-1.3821",
      "deal-intel-utils": "static-1.1719",
      "storybook-react": "static-1.31",
      "reporting-client-types": "static-1.2439",
      "react-flip-move": "static-1.68",
      "FireAlarmUi": "static-1.4448",
      "sales-templates-service-types-lib": "static-1.4103",
      "ui-asset-management-lib": "static-1.10913",
      "association-settings-lib": "static-1.10054",
      "collaboration-sidebar": "static-1.57550",
      "conditional-property-settings-modal": "static-1.12276",
      "data-model-commons-lib": "static-1.12331",
      "final-form": "static-1.68",
      "html-to-image": "static-1.52",
      "nudge-client-utils": "static-1.2400",
      "object-definition-builder-lib": "static-1.7004",
      "property-management-iframe": "static-1.12878",
      "property-usages-lib": "static-1.5332",
      "reactflow": "static-1.62",
      "simple-data-table": "static-1.2547",
      "used-in-list-lib": "static-1.6859",
      "visual-association": "static-1.5787",
      "highcharts": "static-8.102",
      "reporting-visualizations": "static-1.59225",
      "ui-extensibility-client-types": "static-1.3856",
      "microsoft-drive-integration-lib": "static-1.91",
      "automation-platform-service-types": "static-1.2561",
      "ContentData": "static-1.68182",
      "email-portal-health-service-types": "static-1.896",
      "marketing-email-service-types": "static-1.1856",
      "messaging-shared-utils-lib": "static-1.316",
      "messaging-user-info-utils-lib": "static-1.486",
      "content-whatsapp-service-types": "static-1.324",
      "marketing-platform-lib": "static-1.6770",
      "short-messages-app-service-client": "static-1.3901",
      "ui-tool-access": "static-1.10067",
      "onboarding-data-sync-lib": "static-1.1825",
      "growth-onboarding-next-action-components": "static-1.1706",
      "user-context-client": "static-1.4531",
      "nest": "static-1.144",
      "calling-orchestration-schema": "static-1.35447",
      "sales-views-client-types": "static-1.4182",
      "trellis-story-utils": "static-1.4437",
      "hub-http-contrib": "static-1.2962",
      "interframe": "static-3.4682",
      "tinymce-data": "static-1.40218",
      "ui-addon-sales-email": "static-1.5131",
      "codemirror": "static-5.93",
      "layout-dnd-components": "static-1.12291",
      "layout-dnd-utils": "static-1.11266",
      "react-codemirror": "static-1.10543",
      "ui-brand-identity-lib": "static-1.14886",
      "NamespacedHubStyle": "static-2.9000",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9807",
      "ai-settings-ui-library": "static-1.7757",
      "copilot-plugins": "static-1.10876",
      "products-ui-components": "static-1.39742",
      "quotes-ui-lib": "static-1.80392",
      "zustand": "static-1.72",
      "accounting-integrations-ui-components": "static-1.6934",
      "invoices-ui-lib": "static-1.54469",
      "commerce-products-api": "static-1.2170",
      "invoices-iframe-lib": "static-1.56527",
      "quotes-modal-lib": "static-1.102349",
      "platform-infra-nav-components": "static-1.7601",
      "reporting-ui-components": "static-2.64420",
      "subscription-experience-data-types": "static-1.14788",
      "marketplace-ui-apps-core": "static-1.17903",
      "stripe-connect-js": "static-1.67",
      "ui-addon-react-router-dom": "static-1.9464",
      "nested-table": "static-1.146",
      "association-translator": "static-1.3100",
      "crm-settings-header-lib": "static-1.8259",
      "settings-ui-nav": "static-2.10110",
      "chatspot-widget-iframe": "static-1.20907",
      "collaboration-sidebar-common": "static-1.2347",
      "crm-properties-common-lib": "static-1.5796",
      "ui-addon-draggable-compat": "static-2.4174",
      "nudge-custom-function-registry": "static-1.2157",
      "nudge-renderer-utils": "static-1.2476",
      "whisper-core-api": "static-1.6370",
      "property-management-common": "static-1.5166",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15006",
      "advanced-menus-lib": "static-1.11962",
      "ExportDialog": "static-6.10310",
      "ui-memberships-settings-lib": "static-1.33819",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9591",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.14042",
      "highlight.js": "static-1.77",
      "reporting-action-components": "static-1.41058",
      "reporting-snowflake": "static-1.55767",
      "commerce-tax-lib": "static-1.439",
      "property-description-translator": "static-1.3769",
      "commerce-analytics-service-client": "static-1.3557",
      "totals-ui-components": "static-1.23359",
      "reporting-plugins": "static-1.10165",
      "reporting-reports": "static-1.66827",
      "edison-service-client-types": "static-1.306",
      "developer-experience-shared-components": "static-1.10428",
      "marketplace-ui-client-types": "static-1.16777",
      "marketplace-ui-common": "static-1.19370",
      "ui-addon-integrations-directory-panel": "static-2.7913",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.92",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15005",
      "simple-menus-lib": "static-1.16522",
      "academy-common-lib": "static-1.13502",
      "dashboard-lib": "static-1.81202",
      "share-with-third-party-component-lib": "static-1.8616",
      "commerce-totals-service-types": "static-1.3753",
      "campaign-roi-lib": "static-1.8743",
      "apps-service-types": "static-1.3797",
      "oauth-service-types": "static-1.4169",
      "academy-service-client": "static-1.3600",
      "croppie": "static-2.10",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28838",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9595",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4635",
      "atom": "/atom/static-1.4990",
      "conversations-async-data": "/conversations-async-data/static-2.7586",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8800",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15890",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12709",
      "conversations-message-history": "/conversations-message-history/static-1.12435",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10421",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22201",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5514",
      "hs-test-utils": "/hs-test-utils/static-1.7932",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11379",
      "I18n": "/I18n/static-7.1605",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2937",
      "jasmine-runner": "/jasmine-runner/static-1.6387",
      "quartz": "/quartz/static-1.6896",
      "react-dlb": "/react-dlb/static-1.77",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.63",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4392",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4451",
      "usage-tracker": "/usage-tracker/static-1.7256",
      "usage-tracker-core": "/usage-tracker-core/static-1.7106",
      "usage-tracker-public": "/usage-tracker-public/static-1.7067",
      "viral-links-lib": "/viral-links-lib/static-1.6969",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6056",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4728",
      "conversations-prop-types": "/conversations-prop-types/static-1.7374",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20938",
      "cssUtils": "/cssUtils/static-1.772",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.325",
      "foundations-components": "/foundations-components/static-1.7772",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6141",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.184",
      "react-aria": "/react-aria/static-1.64",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1.16579",
      "react-utils": "/react-utils/static-2.5278",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8064",
      "signup-constants": "/signup-constants/static-1.18706",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5670",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5867",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3337",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.80",
      "quartz-config": "/quartz-config/static-1.674",
      "quartz-core": "/quartz-core/static-1.6115",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4771",
      "foundations-theming": "/foundations-theming/static-1.4334",
      "UIComponents": "/UIComponents/static-3.8326",
      "customer-data-email": "/customer-data-email/static-1.17895",
      "cv-backend-services": "/cv-backend-services/static-1.1542",
      "immutable-less": "/immutable-less/static-1.4572",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7170",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32917",
      "customer-data-objects": "/customer-data-objects/static-1.7580",
      "icons": "/icons/static-2.639",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4564",
      "ui-images": "/ui-images/static-2.1132",
      "HeadJS": "/HeadJS/static-2.736",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3043",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.150",
      "i18n-data": "/i18n-data/static-1.219",
      "moment-timezone": "/moment-timezone/static-5.81",
      "jasmine": "/jasmine/static-4.4243",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7953",
      "HubStyle": "/HubStyle/static-2.11687",
      "quartz-i18n": "/quartz-i18n/static-1.571",
      "sassPrefix": "/sassPrefix/static-1.154",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4041",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2050",
      "hs-story-utils": "/hs-story-utils/static-1.9350",
      "react-virtualized": "/react-virtualized/static-2.97",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1585",
      "ui-fonts": "/ui-fonts/static-1.641",
      "hs-locale-management": "/hs-locale-management/static-1.19",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3852",
      "history": "/history/static-4.47",
      "quartz-routing": "/quartz-routing/static-1.326",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5673",
      "bender-build-tools": "/bender-build-tools/static-1.3093",
      "dispatcher": "/dispatcher/static-1.134",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.821",
      "hubspotter-http": "/hubspotter-http/static-1.4587",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.510",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.571",
      "quartz-head": "/quartz-head/static-1.561",
      "quartz-test": "/quartz-test/static-1.571",
      "quartz-tracking": "/quartz-tracking/static-1.275",
      "usage-tracker-container": "/usage-tracker-container/static-1.7246",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2817",
      "foundations-theming-base": "/foundations-theming-base/static-1.3319",
      "stylex": "/stylex/static-1.30",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4570",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9746",
      "FileManagerCore": "/FileManagerCore/static-1.38866",
      "FileManagerLib": "/FileManagerLib/static-1.39007",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4797",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5163",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10267",
      "ts-schema": "/ts-schema/static-1.4013",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8738",
      "avatar-components": "/avatar-components/static-1.2413",
      "content-assistance-lib": "/content-assistance-lib/static-1.7634",
      "crm-component-utils": "/crm-component-utils/static-1.38856",
      "crm-display-components": "/crm-display-components/static-1.24606",
      "crm-fe-perf": "/crm-fe-perf/static-1.22825",
      "crm-links": "/crm-links/static-1.6198",
      "crm-message-bus": "/crm-message-bus/static-1.42763",
      "crm-search-service-types": "/crm-search-service-types/static-1.1071",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5255",
      "customer-data-communicator": "/customer-data-communicator/static-1.45281",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39458",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12941",
      "customer-data-properties": "/customer-data-properties/static-1.51260",
      "customer-data-rte": "/customer-data-rte/static-1.32785",
      "draft-plugins": "/draft-plugins/static-2.21534",
      "file-manager-components": "/file-manager-components/static-1.23367",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6794",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7845",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18004",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10441",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.419",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8011",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17871",
      "universal-associations-select": "/universal-associations-select/static-1.10933",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.638",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3777",
      "property-translator": "/property-translator/static-1.5324",
      "chirp-fetch": "/chirp-fetch/static-1.1802",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9779",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9777",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4942",
      "react-dnd-compat": "/react-dnd-compat/static-1.4539",
      "audio-components": "/audio-components/static-1.5796",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29152",
      "FileManagerImages": "/FileManagerImages/static-1.36518",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.797",
      "immerable": "/immerable/static-1.4072",
      "ui-universal-auth": "/ui-universal-auth/static-1.8873",
      "video-components": "/video-components/static-1.13021",
      "video-data-lib": "/video-data-lib/static-1.34676",
      "video-embed": "/video-embed/static-1.35510",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.256",
      "chatspot-core": "/chatspot-core/static-1.20916",
      "ContentUtils": "/ContentUtils/static-1.68107",
      "copilot-toolkit": "/copilot-toolkit/static-1.10903",
      "superstore": "/superstore/static-1.4688",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8616",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28315",
      "card-properties-lib": "/card-properties-lib/static-1.43932",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36869",
      "crm-actions": "/crm-actions/static-1.6237",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43342",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9106",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8004",
      "customer-data-tracking": "/customer-data-tracking/static-1.6804",
      "hs-resources": "/hs-resources/static-1.60",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3525",
      "pulse": "/pulse/static-1.467",
      "framework-data-table": "/framework-data-table/static-2.11729",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8994",
      "calling-error-reporting": "/calling-error-reporting/static-1.31227",
      "calling-internal-common": "/calling-internal-common/static-1.31221",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6460",
      "crm_data": "/crm_data/static-4.91700",
      "customer-data-content": "/customer-data-content/static-1.27127",
      "draft-content-plugins": "/draft-content-plugins/static-1.28053",
      "draft-convert": "/draft-convert/static-2.71",
      "draft-extend": "/draft-extend/static-3.73",
      "draft-js": "/draft-js/static-5.76",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23857",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24199",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17996",
      "integration-settings-components": "/integration-settings-components/static-1.15231",
      "integrations-lib": "/integrations-lib/static-1.15856",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5516",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7705",
      "nav-meta": "/nav-meta/static-1.29375",
      "onboarding-scopes": "/onboarding-scopes/static-1.6384",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6056",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37761",
      "react-colorpicker": "/react-colorpicker/static-2.10129",
      "reference-resolvers": "/reference-resolvers/static-1.8088",
      "rich-text-lib": "/rich-text-lib/static-1.19695",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3762",
      "sequences-lib": "/sequences-lib/static-1.7904",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11069",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8970",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8961",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10068",
      "user-context": "/user-context/static-1.5020",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5390",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21893",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13075",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4638",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3944",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6699",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.896",
      "onboarding-tours": "/onboarding-tours/static-1.16452",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13437",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21440",
      "calling-global-api": "/calling-global-api/static-1.64184",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65566",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57860",
      "commerce-products-lib": "/commerce-products-lib/static-1.9223",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3732",
      "external-options-client-types": "/external-options-client-types/static-1.4093",
      "google-libphonenumber": "/google-libphonenumber/static-1.36",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4158",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.549",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3626",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48467",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3901",
      "property-value-citations": "/property-value-citations/static-1.1874",
      "smart-property-lib": "/smart-property-lib/static-1.6516",
      "tiered-pricing": "/tiered-pricing/static-1.1043",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10910",
      "video-components-external": "/video-components-external/static-1.11018",
      "batch-promise": "/batch-promise/static-1.1472",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4077",
      "persist-promise": "/persist-promise/static-1.3629",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25126",
      "knowledge-content-types": "/knowledge-content-types/static-1.8465",
      "payment-link-components": "/payment-link-components/static-1.23300",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9806",
      "call-summary": "/call-summary/static-1.38874",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9925",
      "laboratory-lib": "/laboratory-lib/static-3.7078",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5723",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9393",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.668",
      "content-icons-ui": "/content-icons-ui/static-1.2205",
      "social-insights-client-types": "/social-insights-client-types/static-1.21858",
      "outpost": "/outpost/static-1.4110",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4729",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5513",
      "magpie-types": "/magpie-types/static-1.4973",
      "simple-logging-lib": "/simple-logging-lib/static-1.2971",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6502",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45778",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15634",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18838",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18303",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10162",
      "directed-graph": "/directed-graph/static-1.857",
      "event-emitter": "/event-emitter/static-1.867",
      "fast-json-patch": "/fast-json-patch/static-1.61",
      "customer-data-associations": "/customer-data-associations/static-1.7246",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1715",
      "reporting-data": "/reporting-data/static-1.67149",
      "tanstack-virtual": "/tanstack-virtual/static-1.28",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4688",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3545",
      "self-service-api": "/self-service-api/static-1.10164",
      "crm_universal": "/crm_universal/static-1.21867",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9117",
      "content-embed-lib": "/content-embed-lib/static-1.7260",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12076",
      "remote-ui": "/remote-ui/static-1.63",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5517",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16774",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2929",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13271",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10293",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.387",
      "messaging-types-lib": "/messaging-types-lib/static-1.45742",
      "data-token-picker": "/data-token-picker/static-1.16266",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7761",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5255",
      "navigation-messaging": "/navigation-messaging/static-1.7065",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18270",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17388",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.518",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.867",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8549",
      "growth-data-modal": "/growth-data-modal/static-1.5304",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2990",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1678",
      "navigation-components": "/navigation-components/static-1.17738",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4666",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7449",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10957",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.670",
      "commerce-permissions": "/commerce-permissions/static-1.685",
      "products-iframe-lib": "/products-iframe-lib/static-1.7698",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10161",
      "data-agent-kit": "/data-agent-kit/static-1.68",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9862",
      "fsm": "/fsm/static-1.3654",
      "policy-lib": "/policy-lib/static-1.6703",
      "react-tinymce": "/react-tinymce/static-1.55007",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54133",
      "tinymce-plugins": "/tinymce-plugins/static-1.57247",
      "tinymce-themes": "/tinymce-themes/static-1.56103",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11992",
      "content-media-compositions": "/content-media-compositions/static-2.15999",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18788",
      "ui-addon-opt": "/ui-addon-opt/static-4.8300",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5947",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5004",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7950",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19195",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8487",
      "wootric-nps": "/wootric-nps/static-1.6902",
      "nav-client-types": "/nav-client-types/static-1.2277",
      "purchase-motions-api": "/purchase-motions-api/static-1.5726",
      "reactive-lib": "/reactive-lib/static-1.643",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36934",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39292",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11685",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54453",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21234",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17507",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71671",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8396",
      "utility-belt": "/utility-belt/static-1.2459",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22391",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7364",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5571",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14584",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5031",
      "qrcode-generator": "/qrcode-generator/static-1.67",
      "trials-service-types": "/trials-service-types/static-1.3821",
      "deal-intel-utils": "/deal-intel-utils/static-1.1719",
      "storybook-react": "/storybook-react/static-1.31",
      "reporting-client-types": "/reporting-client-types/static-1.2439",
      "react-flip-move": "/react-flip-move/static-1.68",
      "FireAlarmUi": "/FireAlarmUi/static-1.4448",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4103",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10913",
      "association-settings-lib": "/association-settings-lib/static-1.10054",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57550",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12276",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12331",
      "final-form": "/final-form/static-1.68",
      "html-to-image": "/html-to-image/static-1.52",
      "nudge-client-utils": "/nudge-client-utils/static-1.2400",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7004",
      "property-management-iframe": "/property-management-iframe/static-1.12878",
      "property-usages-lib": "/property-usages-lib/static-1.5332",
      "reactflow": "/reactflow/static-1.62",
      "simple-data-table": "/simple-data-table/static-1.2547",
      "used-in-list-lib": "/used-in-list-lib/static-1.6859",
      "visual-association": "/visual-association/static-1.5787",
      "highcharts": "/highcharts/static-8.102",
      "reporting-visualizations": "/reporting-visualizations/static-1.59225",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3856",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.91",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2561",
      "ContentData": "/ContentData/static-1.68182",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.896",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1856",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.316",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.486",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.324",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6770",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3901",
      "ui-tool-access": "/ui-tool-access/static-1.10067",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1825",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1706",
      "user-context-client": "/user-context-client/static-1.4531",
      "nest": "/nest/static-1.144",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35447",
      "sales-views-client-types": "/sales-views-client-types/static-1.4182",
      "trellis-story-utils": "/trellis-story-utils/static-1.4437",
      "hub-http-contrib": "/hub-http-contrib/static-1.2962",
      "interframe": "/interframe/static-3.4682",
      "tinymce-data": "/tinymce-data/static-1.40218",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5131",
      "codemirror": "/codemirror/static-5.93",
      "layout-dnd-components": "/layout-dnd-components/static-1.12291",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11266",
      "react-codemirror": "/react-codemirror/static-1.10543",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14886",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9000",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9807",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7757",
      "copilot-plugins": "/copilot-plugins/static-1.10876",
      "products-ui-components": "/products-ui-components/static-1.39742",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80392",
      "zustand": "/zustand/static-1.72",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6934",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54469",
      "commerce-products-api": "/commerce-products-api/static-1.2170",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56527",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102349",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7601",
      "reporting-ui-components": "/reporting-ui-components/static-2.64420",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14788",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17903",
      "stripe-connect-js": "/stripe-connect-js/static-1.67",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9464",
      "nested-table": "/nested-table/static-1.146",
      "association-translator": "/association-translator/static-1.3100",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8259",
      "settings-ui-nav": "/settings-ui-nav/static-2.10110",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20907",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2347",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5796",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4174",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2157",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2476",
      "whisper-core-api": "/whisper-core-api/static-1.6370",
      "property-management-common": "/property-management-common/static-1.5166",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15006",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11962",
      "ExportDialog": "/ExportDialog/static-6.10310",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33819",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9591",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14042",
      "highlight.js": "/highlight.js/static-1.77",
      "reporting-action-components": "/reporting-action-components/static-1.41058",
      "reporting-snowflake": "/reporting-snowflake/static-1.55767",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.439",
      "property-description-translator": "/property-description-translator/static-1.3769",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3557",
      "totals-ui-components": "/totals-ui-components/static-1.23359",
      "reporting-plugins": "/reporting-plugins/static-1.10165",
      "reporting-reports": "/reporting-reports/static-1.66827",
      "edison-service-client-types": "/edison-service-client-types/static-1.306",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10428",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16777",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19370",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7913",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.92",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15005",
      "simple-menus-lib": "/simple-menus-lib/static-1.16522",
      "academy-common-lib": "/academy-common-lib/static-1.13502",
      "dashboard-lib": "/dashboard-lib/static-1.81202",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8616",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3753",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8743",
      "apps-service-types": "/apps-service-types/static-1.3797",
      "oauth-service-types": "/oauth-service-types/static-1.4169",
      "academy-service-client": "/academy-service-client/static-1.3600",
      "croppie": "/croppie/static-2.10",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28838",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};